import { useState, type ReactNode, type FC } from 'react';
import ArticleListingContext, { type ArticleListingContextProps, type ArticleListingProps } from './ArticleListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';

export interface ArticleListingProviderProps extends ArticleListingProps {
    children: ReactNode;
}

const ArticleListingProvider: FC<ArticleListingProviderProps> = ({
    listing,
    children,
    serverPageUrl,
    ...restProps
}) => {
    const activeFiltersInitialValue = getActiveFiltersFromURL(listing.filters, new URL(serverPageUrl).search);
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const [page, setPage] = useState(getPageFromURL(new URL(serverPageUrl).search));

    const providerValue: ArticleListingContextProps = {
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        listing,
        serverPageUrl,
        ...restProps,
    };

    return (
        <ArticleListingContext.Provider value={providerValue}>
            {children}
        </ArticleListingContext.Provider>
    );
};

export default ArticleListingProvider;
